import React from "react";
import { dateBadge } from "@/lib/api";

export default function DateBadge({ date, className = "" }) {
  const { month, day } = dateBadge(date);
  return (
    <div
      data-testid="date-badge"
      className={`flex flex-col items-center justify-center bg-black/85 backdrop-blur-sm border border-white/10 rounded-lg px-2.5 py-1.5 leading-none text-center ${className}`}
    >
      <span className="font-oswald text-gold text-[10px] font-bold tracking-widest uppercase">{month}</span>
      <span className="font-display text-white text-xl">{day}</span>
    </div>
  );
}
